import React, { useState } from 'react'
import { TextField } from '@navikt/ds-react'
import { DashboardTabNewProps } from 'index.d'
import styled from 'styled-components'
import { SuccessFilled, ErrorFilled } from '@navikt/ds-icons'

const MarginLeftDiv = styled.div`
  margin-left: 0.5rem;
`
const NewDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: 0.5rem;
`
const Icon = styled.div`
  display: flex;
  cursor: pointer;
`
const DashboardTabNew: React.FC<DashboardTabNewProps> = ({
  handleAcceptNewTab, handleRejectNewTab
}: DashboardTabNewProps): JSX.Element => {
  const [tabNewLabel, setTabNewLabel] = useState<string>('')
  return (
    <NewDiv>
      <TextField
        hideLabel
        label='new'
        size='small'
        value={tabNewLabel}
        onChange={(e: any) => {
          e.preventDefault()
          e.stopPropagation()
          setTabNewLabel(e.target.value)
        }}
        onClick={(e: any) => {
          e.preventDefault()
          e.stopPropagation()
        }}
      />
      <MarginLeftDiv>
        <Icon>
          <SuccessFilled color='green' width={24} onClick={() => handleAcceptNewTab(tabNewLabel)} />
        </Icon>
      </MarginLeftDiv>
      <MarginLeftDiv>
        <Icon>
          <ErrorFilled color='red' width={24} onClick={() => handleRejectNewTab()} />
        </Icon>
      </MarginLeftDiv>
    </NewDiv>
  )
}

export default DashboardTabNew
